import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SecureUplodDocumentComponent } from './secure-uplod-document.component';
import { IonicModule } from '@ionic/angular';
import { ReactiveFormsModule } from '@angular/forms';
import { ComponentsModule } from 'src/app/components/components.module';



@NgModule({
  declarations: [
    SecureUplodDocumentComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    ReactiveFormsModule,
    ComponentsModule
  ]
})
export class SecureUplodDocumentModule { }
